export default {
  title: 'Track your order',
  text: 'Delivered by',
  buttons: {
    track_driver: 'Get Live Order Updates →',
  },
};
